import { Pagination } from '../../../Components/Pagination/Pagination';
import noImage from '../../../Assets/Images/no-img.jpg';
import { ActionMenu } from '../../../Components/ActionMenu/ActionMenu';
import { useFormatImageUrl } from '../../../utils/formatImageUrl';

interface MerchContentProps {
  merchData: any;
  currentPage: number;
  onPageChange: (page: number) => void;
  onDeleteMerch: (id: number) => void;
  onEditMerch: (merchItem: any) => void;
}

export const MerchContent = ({
  merchData,
  currentPage,
  onPageChange,
  onDeleteMerch,
  onEditMerch,
}: MerchContentProps) => {
  const formatImageUrl = useFormatImageUrl();

  const handleDelete = async (id: number) => {
    await onDeleteMerch(id);
  };

  if (merchData.merch.length === 0) {
    return <div className="no-data-message">No merch found</div>;
  }

  return (
    <div className="merch-content">
      <div className="merch__list">
        {merchData.merch.map((item: any) => (
          <div key={item.id} className="merch__item">
            <ActionMenu onEdit={() => onEditMerch(item)} onDelete={() => handleDelete(item.id)} />
            <img
              src={formatImageUrl(item.imageUrl)}
              alt={item.name}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = noImage;
              }}
            />
            <div className="content">
              <div className="tag">{item.merchCategory.name}</div>
              <h3>{item.name}</h3>
              <p>{item.description}</p>
              <span className="agency-name">{item.agency.name}</span>
            </div>
          </div>
        ))}
      </div>
      {merchData.totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={merchData.totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};
